module.exports = __webpack_public_path__ + "static/index/img/baikal-208.1d1ce9df.jpg";